module.exports = __webpack_public_path__ + "img/avatar3.674bf6a3.png";